import React from 'react';
import { Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { SURA_BLUE, SURA_BLUE2 } from './palette';

const fmtFull = (v) => `$${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/* ─── Gastos por Centro de Costo ───────────────────────────────────
   Widget reutilizable: recibe `data` ya agregada y ordenada
   ([{ centro_costo, total }]) y dibuja el ranking con barras. */
const GastosPorCentroCosto = ({ data, subtitle, headerRight, emptyText = 'Sin datos para este período' }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
    <div className="flex items-center gap-2 mb-6">
      <Building2 size={16} style={{ color: SURA_BLUE }} />
      <h3 className="text-xs font-bold uppercase tracking-wider m-0" style={{ color: SURA_BLUE }}>
        Gastos por Centro de Costo
      </h3>
      {headerRight ? (
        <div className="ml-auto">{headerRight}</div>
      ) : subtitle ? (
        <span className="text-xs text-gray-400 font-medium ml-auto">{subtitle}</span>
      ) : null}
    </div>

    {(!data || data.length === 0) ? (
      <p className="text-sm text-gray-400 italic text-center py-4">{emptyText}</p>
    ) : (
      <div className="space-y-3">
        {data.map((cc, i) => {
          const maxVal = data[0]?.total || 1;
          const pct = Math.round(cc.total / maxVal * 100);
          return (
            <div key={cc.centro_costo} className="flex items-center gap-4">
              <div
                className="w-6 h-6 rounded flex items-center justify-center text-[10px] font-bold flex-shrink-0"
                style={{ background: i < 3 ? SURA_BLUE : '#f1f5f9', color: i < 3 ? '#fff' : '#94a3b8' }}
              >
                {i + 1}
              </div>
              <span className="text-xs font-medium text-gray-700 w-52 flex-shrink-0 truncate">{cc.centro_costo}</span>
              <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                <motion.div
                  className="h-full rounded-full"
                  style={{ background: i === 0 ? SURA_BLUE : i === 1 ? SURA_BLUE2 : '#93C5FD' }}
                  initial={{ width: 0 }}
                  animate={{ width: `${pct}%` }}
                  transition={{ duration: 0.7, delay: i * 0.06, ease: 'easeOut' }}
                />
              </div>
              <span className="text-xs font-bold text-gray-800 font-mono w-24 text-right flex-shrink-0">{fmtFull(cc.total)}</span>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default GastosPorCentroCosto;
